// =============================================================================
// HUB OPERATION - Dashboard (CC-25b — version "grille de widgets")
// =============================================================================
// Le rendu historique est conservé dans _OperationDashboardLegacy.jsx et
// exposé en widget unique 'operation_dashboard_complet' du catalogue.
// JJ peut désactiver / réordonner ce widget, et l'enrichir progressivement
// avec des widgets plus granulaires (KPIs / Pipeline / Évolution séparés).
// =============================================================================
import DashboardGrid from "../../components/dashboard/DashboardGrid";

export default function OperationDashboard(props) {
  return (
    <DashboardGrid hub="operation" title="Dashboard Opération" />
  );
}
